$(function(){
  $( document ).ready(()=>$(document).trigger('page:ready'));
  //helper function
  
  //  * Will return:
  //  * False for: for all strings with chars
  //  * True for: false, null, undefined, 0, 0.0, "", " ".

  function isBlank(str){
    return (!!!str || /^\s*$/.test(str));
  }

  //load flag
  var flag=$('._flagImg');
  $.getJSON("https://api.ipify.org?format=json",function(data) {
      $.ajax({
        type: "GET",
        url: "https://ip2c.org/"+data.ip,
        success: function (data) {
          console.log("here->",data);
          //response 1;BD;BGD;Bangladesh
          let code=data.split(";")[1];
          var url="https://flagcdn.com/"+code.toLowerCase()+".svg";
          flag.attr("src", url);
          flag.attr("title", code);
          //alert(code);
    
        },
        error: function (err) {
          console.log(err);
        },
        
      });
  });
  //flag old logic
  //   $.getJSON("https://ipinfo.io", function(data) {
  //     var c=data.country;
  //     //var url="https://www.countryflags.io/"+c+"/shiny/32.png";
  //     var url="https://flagcdn.com/"+c.toLowerCase()+".svg";
  //     flag.attr("src", url);
  //     flag.attr("title", c);
  //     //.attr("src", "ss");
  //     //$('#__flagImg').attr("src", "https://www.countryflags.io/"+c+"/shiny/32.png");
  //     console.log("https://www.countryflags.io/"+c+"/shiny/32.png");
  //   });
  //flag old logic
  //flag end

  // Get the btn
  let topBtn = document.querySelector('#scrollToTop');
  // On Click, Scroll to the page's top
  topBtn.onclick = () => window.scrollTo({ top: 0, behavior: 'smooth'}) // Remove behavior: 'smooth' if you don't want smooth scrolling
  //bundle-product page ui
  if($( window ).width()<=768){
    $('.swatch-content img').click(function(e){
      e.preventDefault();
      //$('.sidebar-close.sidebar_1').hide();
      fillContents($(this));
      $('.swatch-card').hide();
      $('.sidebar-wrap.sidebar_mob').addClass('open');
      $('.sidebar-close.sidebar_mob').click(function(){

        //alert('Hello');
       // $('.sidebar-close.sidebar_1').show();
        $('.sidebar-wrap.sidebar_mob').removeClass('open');
      });

    });
  }
  else{
    $('.swatch-content img').click(function(e){
      e.preventDefault();
      var index=$(this).attr('fc');
      var flkty = new Flickity('.product-slideshow');
      flkty.select( index );
    });

  }
  //Set data contents
  function fillContents(t){
    var url=$('.product-main-slide.is-selected').find('img.photoswipe__image').data('photoswipe-src');
    $('.sidebar-wrap.sidebar_mob').find('img.sP_swatch').attr('src',url);
    $('div.sP_text').html(t.parent().find('.swatch-card').html());
  }
  //console.log('ui');
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {    
    var dropdown = acc[i].querySelector('.toggle_menu');
    if(!dropdown) continue;
    dropdown.addEventListener("click", function(e) {
      //e.preventDefault();
      console.log(1);
      this.parentElement.classList.toggle("active");
      console.log(this.parentElement)
      this.parentElement.nextElementSibling.classList.toggle("isOpen");
      //var panel = this.parentElement.nextElementSibling;
    });
  }

    /**
   * Fix wishlist page add to cart START
  */
  //update cart and open drawer
  function c_u_o(){
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:build", {
        bubbles: true,
      })
    );
    //$('#HeaderCartTrigger')[0].click();
  };

  function checkCounter(cb){
   let gt;
   let c=0;
   gt= setInterval(function(){
    const item=$('#ssw-page').find('.ssw-fave-item');
    if(c>60 || item.length){
      console.log('iter:'+c+'times'+',found:'+item.length);
      //item.find('.ssw-fave-product-actions').hide();
      clearInterval(gt);
      cb(item);
    }
    c++;
   },500);
  }

  function checkSSWModal(callback,e){
    let gt;
    let c=0;
    gt= setInterval(function(){
     const item=$(":root").hasClass('ssw-modal-open');
     if(c>60 || item){
       console.log('found',c+','+item);
       clearInterval(gt);
       item && callback(e);
     }
     c++;
    },500);
  }

  function showCritical(t,className){
    t.find('.ssw-fave-product-actions').removeClass(className);
    //t.find('a.ssw-product-link').show();
  }

  function hideCritical(t,className){
    t.find('.ssw-fave-product-actions').addClass(className);
    //t.find('a.ssw-product-link').hide();
  }

  //check hardware option metafields
  async function getMeta(t){
    var h=t.data('handle');
    var ch=t.find('.ssw-fave-variant-choose');
    var atc=t.find('.ssw-fave-add-to-cart');
    hideCritical(t,'meta-hide');
    var v=await fetch(`/products/${h}?view=meta-checker`).then(res => res.json()).then(s=>JSON.parse(s.metafields));
    showCritical(t,'meta-hide');
    // if (!v) return;
    //console.table(v);
    //stop modal and redirect redirect <script link product_link.js>
    t.find('a.ssw-product-link').removeClass('ssw-product-link');
    t.click((e)=>{   
      window.location.pathname='/products/'+h;
    });

    atc.addClass("ssw-sold-out").removeAttr("style").removeAttr("target");
    atc.text("View Product").attr("href","/products/"+h).attr("target","_blank");
    ch.hide();
    atc.unbind("click");
    ch.attr('data-metaf','true');
  }

  //check product multiples template defined for products
  async function checkMultiples(t){
    
    var ch=t.find('.ssw-fave-variant-choose');
    var atc=t.find('.ssw-fave-add-to-cart');
    hideCritical(t,'multiples-hide');
    let h=t.data('handle');
    let text=await fetch(`/products/${h}`).then(res => res.text());
    let parser = new DOMParser();
    let doc = parser.parseFromString(text, "text/html");
    const multipleExist=doc.querySelectorAll('select.quantity--multiple').length>0;
    showCritical(t,'multiples-hide');
    if(!multipleExist) return;
    t.find('a.ssw-product-link').removeClass('ssw-product-link');

    t.click((e)=>{   
      window.location.pathname='/products/'+h;
    });
    
    atc.addClass("ssw-sold-out").removeAttr("style").removeAttr("target");
    atc.text("View Product").attr("href","/products/"+h).attr("target","_blank");
    ch.hide();
    atc.unbind("click");
    console.log(multipleExist);
  }

  function loopItem(item){
    item.each(function(){
      const t=$(this);
      //t.off();
      
      var h=t.data('handle');
      if(!h){return;}
      var ch=t.find('.ssw-fave-variant-choose');
      var atc=t.find('.ssw-fave-add-to-cart');

      //console.log(t.data('handle'));
      //get metafields
      getMeta(t);
      checkMultiples(t);

      //get product data
      jQuery.getJSON('/products/'+h+'.js', function(product) {
        //console.dir(product);

        if (!product.available){
           atc.addClass("ssw-sold-out").removeAttr("style").removeAttr("target");
           atc.text("Sold Out");
           atc.attr("href","/products/"+h);
           atc.attr("target","_blank");
           ch.hide();
           atc.unbind("click");
        }
        t.find('.ssw-fave-product-actions').removeClass('hide');
        //console.log('data',product);
      });

    });
  }
  function soldUpdate(){
    //modal ATC button cart update
    const atc_m=$('.ssw-product-variant-add-to-cart');
    atc_m.each(function(){
      $(this).click(function(){
        $(document).ajaxComplete(function(e, xhr, options) {
          //console.log($(e.currentTarget));
            c_u_o();
            console.log('complete');
          $(document).unbind('ajaxComplete');
        });
      });
    });
  }
  function w_loaded(){
      //alert('loaded');
      if(window.location.pathname!='/pages/wishlist'){return;}

      //add sold out for products with inventory quantity 0
      checkCounter(loopItem);

      //$('.ssw-fave-list-container').show();
      soldUpdate();

  };

  document.addEventListener('SSW_WISHLIST_CRITICAL_LOADED',w_loaded);
  $( document ).on( "sswproductaddedtocartafter", function() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:build", {
        bubbles: true,
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:open", {
        bubbles: true,
      })
    );
  });
  //reload page when added to wishlist from drawer
  $(document).on( "sswproductfaveafter", function(e) {
    if(window.location.pathname==="/pages/wishlist"){
      window.location.reload();
    }
  });
  /**
   * Fix wishlist page add to cart END
  */
  //form select for variants
  $('.pr-variant-form form').each(function(){
    var form=$(this);
    var selects=form.find('.customForm_item select');
    //form.attr('select',0);
    selects.each(function(){
      var th=$(this);
      var btn=form.find('.dynamic-btn');

      if(isBlank(th.val())){
        th.next('.label').removeClass('gte');
        th.attr('val','0');
      }
      else{
        th.next('.label').addClass('gte');
        th.attr('val','1');
      }
      if(form.find('select[val=1]').length<5){
        btn.attr('disabled','disabled');
      }
      else{
        btn.removeAttr('disabled');
      }

      th.change(function(){
        console.log(th.val());
        if(isBlank(th.val())){
          //form.attr('select', parseInt(form.attr('select')) - 1);
          th.attr('val','0');
          th.next('.label').removeClass('gte');
          if(form.find('select[val=1]').length<5){
            btn.attr('disabled','disabled');
          }

        }
        else{
          //form.attr('select', parseInt(form.attr('select')) + 1);
          th.attr('val','1');
          th.next('.label').addClass('gte');
          if(form.find('select[val=1]').length>=5){
            btn.removeAttr('disabled');
          }

        }
        //$('.customForm_item .label').text($(this).attr('name'));

      });
    });

  });
  //announcement bar modal
  $('button.asterisk').each(function(){
    var btn=$(this);
    var h=$('div#'+btn.attr('data-wr'));
    btn.click(function(){
      $('body').addClass('no-scroll-mod');
      h.addClass('is-op');
      h.find('.w3-cancel').click(function(){
        $('body').removeClass('no-scroll-mod');
        h.removeClass('is-op');
        $('.slideshow-wrapper').find('.slideshow__pause').trigger('click');
      });
      //alert(btn.attr('id'));
    });
  });
  $('div.sao-link-wrapper').each(function(){
    let a=$(this);
    a.find('button').click(function(){
      let t=$(this);
      t.parent().parent().toggleClass('chimera');
    });
  })
  //sidebar
  $('#triggerSidebar').click(function(e){
     e.preventDefault();
     console.log('toggle sidebar');
     $('.sidebar-wrap.sidebar_1').addClass('open');
  });
  $('.sidebar-close.sidebar_1').click(function(){
    $('.sidebar-wrap.sidebar_1').removeClass('open');
  });

  //Expandable search
  function clearJunk(){
    let jPanel=$('.boost-pfs-search-suggestion-mobile-top-panel');
    let jResult=$('[data-search-box-id=boost-pfs-search-box-mobile]');
    console.log(jPanel.length?'found':'not found jPanel');
    console.log(jResult.length?'found':'not found jResult');
    jPanel.remove();
    jResult.remove();
  };
  $('.boost-pfs-search-form').on('click',function(e){
    if ($( window ).width()<=768) {
      e.preventDefault();
      $('.js-search-head').click();  
    }
  });
  //delegate events
  $('body').on('click','.js-search-head',function(e){
    $('body').hasClass('no_scroll')?$('body').removeClass('no_scroll'):{};
    e.preventDefault();
    let boostSearchbox=$('#boost-pfs-search-box-2');
    const searchForm = $('.site-header__search-container.cust-search_');
    const searchBox = $('#boost-pfs-search-box-mobile');

    if ($( window ).width()<=768) {
      const SC=$(window).scrollTop();
      clearJunk();
      //$('.boost-pfs-search-suggestion-mobile-top-panel').hide();
      $('.boost-pfs-search-suggestion-mobile-overlay').addClass('hide');
      //for mobile view inititalize the positioning of wrapper and search box     
      const searchBoxHeight = 44;
      const classCompressed='header-wrapper--compressed';
      let topdiv=$('.boost-pfs-search-suggestion-mobile-top-panel');
      let wrapper1 = $('[data-search-box-id=boost-pfs-search-box-mobile]');
      let wrapper=$('[data-search-box-id=boost-pfs-search-box-2]');
      let headerWrapper=$('#HeaderWrapper');
      let header=$('.header-layout');
      let headerHeight=header.outerHeight();
      let toolbar=$('[data-section-id=toolbar]');

      //for mobile view inititalize the positioning of wrapper and search box end
      //we will use the boost search input field
      //trigger focus for mobile view;
      if(searchForm.hasClass('is-active')){
        searchForm.removeClass('is-active');
        boostSearchbox.blur();
        //fix scroll
        if(SC<=toolbar.outerHeight()){window.scroll(0,0);}
        //searchBox.blur();
        $('[data-search-box-id=boost-pfs-search-box-2]').removeClass('boost-pfs-search-suggestion-open');
      } else {
        //fix scroll
        if(SC<=toolbar.outerHeight()){window.scroll(0,toolbar.outerHeight()+2);}
        searchForm.addClass('is-active');
        console.log(boostSearchbox.length);
        //give time to print display the box;
        setTimeout(() => {boostSearchbox.focus();}, 300);
        
        $('.site-header__search-btn--cancel').click(function(ev){
          //fix scroll
          if(SC<=toolbar.outerHeight()){window.scroll(0,0);}
          searchForm.removeClass('is-active');
          boostSearchbox.blur();
          $('[data-search-box-id=boost-pfs-search-box-2]').removeClass('boost-pfs-search-suggestion-open');
          $('[data-search-box-id=boost-pfs-search-box-mobile]').hide();
          $(this).unbind(ev);
        });
      }
      

    }
    else{
      //for desktop view
      $('.site-header__search-container.cust_search').toggleClass('is-active');
      $('.site-header__search-btn--cancel').click(function(){
        $('.site-header__search-container.cust_search').removeClass('is-active');
        //alert('CLOSE');
      });
    }

  });
  $( window ).scroll(function() {
    var scrollPos = $(window).scrollTop();
    let navbar=$('#SiteHeader');
    let start=navbar.offset().top;
    if($( window ).width()<=768){//mobile view
      let wrapper=$('.boost-pfs-search-suggestion-mobile.boost-pfs-search-suggestion-wrapper');
      let topdiv=$('.boost-pfs-search-suggestion-mobile-top-panel');

      let h=navbar.find('.header-layout').outerHeight();//43.5
      let off=navbar.offset().top;//29
      let t=start+h;
      //console.log(navbar.outerHeight());
      if(scrollPos>=off){
        //let temp=h+topdiv.outerHeight();
        topdiv.attr('style','top:'+h+'px!important;');
        wrapper.addClass('ving');
      } else{
        //let temp=t+topdiv.outerHeight();
        topdiv.attr('style','top:'+t+'px!important;');
        wrapper.removeClass('ving');
      }
      //console.log('scrolltop:'+scrollPos+'navtop:'+navbar.offset().top);
    } else{//desktop view
      //hide dropdown on scroll
      let dropdown=$('ul#ui-id-2');
      let arrowDropdown=$('.boost-pfs-search-suggestion-popover');
      if(dropdown.length>0){
        dropdown.hide();
        arrowDropdown.hide();
      }
    }
  });

  //text change trigger search
  $('.site-header__search-input').change(function(){

  });
  //continue shopping button on cart
  $('span#Shopping').click(function(){
    $('.js-close-header-cart').click();
  });
  //mobile nav scroll
  $('.mobile-nav-trigger').click(function () {
    if ($('#MobileNav').hasClass('is-active')) {
      //alert('open');
      $(document.body).addClass('no_scroll');
      $('#HeaderWrapper').addClass('nav-open');
      console.log('is-light');
      //
    } else {
      $(document.body).removeClass('no_scroll');
      $('#HeaderWrapper').removeClass('nav-open');
      //$('#HeaderWrapper').removeClass('is-light');
      //alert('close');
    }
  });
  //Cart Close Fix
  $('.js-close-header-cart').click(function(){
    if($('#HeaderWrapper').hasClass('header-wrapper--compressed')){
      $('#HeaderWrapper').removeClass('is-light');
      //console.log('compressed');
    }
    else{
      //console.log('expanded');
    }

  });
  // Close search bar on mobile when mobile nav open
  function closeSearch(){
    const s=$('.cust-search_');
    if($('.cust-search_').hasClass('is-active')){
     s.removeClass('is-active');
    }
  }
  document.addEventListener('MobileNav:open',function(){
    closeSearch();
  });
  $('#HeaderCartTrigger').click(function(){
    if($( window ).width()<=768){
      closeSearch();
    }

  });
  //Megamenu dynamic height
  //function
  function check(wrapper,height) {
    let ty=wrapper.find('.megamenu__featured').find('.product-grid>*').length;
    //console.log(ty);
    if(ty){
        let padding=40;
        let minHeight=wrapper.find('.megamenu__featured').prop('scrollHeight')+padding;
        if(minHeight>height){wrapper.css("max-height",minHeight+'px');}
        //console.log(minHeight+">>"+height);
      }
  }
  $('.site-nav--is-megamenu').each(function(){
    let th= $(this);
    th.hover(function(){
      let l= th.find('.megamenu__cols').children().length;
      let d= th.find('.megamenu__cols').find('.site-nav__dropdown-link').length;
      let wrapper=th.find('.megamenu__wrapper');
      //console.log(wrapper.find('.megamenu__featured').prop('scrollHeight'));
      //console.log(wrapper.find('.megamenu__featured').find('.img-link').length);
      if(d<17){
        //find image minheight
        wrapper.css("max-height",'290px');
        check(wrapper,290);
      }
      else if (d>=17 && d<31) {
        wrapper.css("max-height","320px");
        check(wrapper,320);
      }
      else if (d>=31 && d<41) {
        wrapper.css("max-height","380px");
        check(wrapper,380);
      }
      else {
        wrapper.css("max-height","490px");
        check(wrapper,490);
      }

      //console.log(d);
    });
  });
/*  window.on('mobileNav:open',function(){
  console.log('sssssssssttt');
 }); */
  $('.site-header__search-btn--cancel').click(function(){
    let btn=$('.site-header__search-container.cust-search_');
    if ($( window ).width()<=768) {
      btn.removeClass('is-active');
    }
    else{
      btn.removeClass('is-active');
    }

  });



});
// white glove delivery
$(function () {
  const form = $(".product-single__form");
  const whiteGloveCheckbox = form.find("#white_glove__checkbox");
  const whiteGloveButton = form.find(".add-to-cart--whiteglove");
  const atc = form.find(".add-to-cart");

  // whiteGloveButton.on("click", function (e) {
  //   e.preventDefault();
  //   whiteGloveCheckbox.val("White Glove Service").prop("checked", true);
  //   atc.trigger("click");
  //   whiteGloveCheckbox.val("").prop("checked", false);
  // });

  $(document).on("cart:updated ready ajaxProduct:added", function () {
    console.log("ready");
    theme.cart.getCart().then((cart) => {
      const items = cart.items;
      additionalProductChanged(items);
      updateCheckBox(items)
    });
  });

  $(document).on("cart:build", function() {
    theme.cart.getCart().then((cart) => {
      const items = cart.items;
      updateCheckBox(items)
    });
  })

  theme.cart.getCart().then((cart) => {
    const items = cart.items;
    // console.log('CART ITEMS',items);
    updateCheckBox(items)
  });

  $(document).on(
    "change",
    ".toggle_additional_product",
    toggleWhiteGloveProduct
  );

//   $(document).on('click', 'button[name=checkout]', function(e) {
//     const form = $(this).parents('form');
//     const checkbox = form.find('#CartTermsHeader');

//     $(this).addClass('btn--loading');

//     if (checkbox.length && !checkbox.prop('checked')) {
//       e.preventDefault();
//       showWarningModal(theme.strings.whitegloveConfirmation);
//       $(this).removeClass('btn--loading');
//       return;
//     }
//   });

  function showWarningModal(text) {
    $('#WarningHolder').html(`<p>${text}</p>`);
    const modal = new theme.Modals("WarningModal", "warning");
    modal.open();
  }

  function updateCheckBox(items) {
    return;
    const status = items.some(it => it.id === 39303711621156);

    if (!status) {
      $('.checkox-container').html('');
      return;
    }

    // adding checkout button checkbox
//     $('.checkox-container').html(`<div class="cart__item-row cart__terms">
//       <input type="checkbox" id="CartTermsHeader" class="cart__terms-checkbox">
//         <label for="CartTermsHeader" class="text-label">
//           <small>
//           ${theme.strings.whitegloveCheckbox}
//           </small>
//         </label>
//       </div>`);
  }

  function additionalProductChanged(items) {
    var deliveryAddonId = 39303711621156;
    var deliverableItems = items.filter(
      (item) => item.properties && item.properties.hasOwnProperty("Delivery")
    );
    var deliveryEnabledItems = deliverableItems.filter(
      (item) => item.properties.Delivery === "White Glove Service"
    );

    var addonItems = items.filter(
      (item) => item.variant_id === deliveryAddonId
    );

    const reducer = (a, c) => a + c.quantity;
    const totalDeliveryItem = deliveryEnabledItems.reduce(reducer, 0);

    if (totalDeliveryItem === addonItems[0]?.quantity) return;
    if (totalDeliveryItem === 0 && addonItems.length === 0) return;

    var newData = {
      updates: {
        [deliveryAddonId]: totalDeliveryItem,
      },
    };

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: newData,
      success: function (data) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:build", {
            bubbles: true,
          })
        );
      },
      error: function (err) {
        console.log(err);
      },
      dataType: "json",
    });
  }

  function toggleWhiteGloveProduct() {
    console.log("toggle");
    var $this = $(this);
    var line = $this.attr("data-line");
    var status = $this.prop("checked");
    var qty = parseInt($this.attr("data-qty"));

    var updateData = {
      line: line,
      quantity: qty,
      properties: {
        Delivery: status ? "White Glove Service" : null,
      },
    };

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: updateData,
      success: function (data) {
        additionalProductChanged(data.items);
      },
      error: function (err) {
        console.log(err);
      },
      dataType: "json",
    });
  }
});

// Gift Wrap
$(function () {
  $(document).on("cart:updated ready ajaxProduct:added", function () {
    theme.cart.getCart().then((cart) => {
      const items = cart.items;
      additionalProductChanged(items);
    });
  });

  $(document).on("change", ".toggle_gift_wrap", toggleGiftWrap);

  function additionalProductChanged(items) {
    var deliveryAddonId = 964996008;
    var deliverableItems = items.filter(
      (item) => item.properties && item.properties.hasOwnProperty("gift_wrap")
    );

    var deliveryEnabledItems = deliverableItems.filter(
      (item) => item.properties.gift_wrap === "true"
    );

    var addonItems = items.filter(
      (item) => item.variant_id === deliveryAddonId
    );

    const reducer = (a, c) => a + c.quantity;
    const totalDeliveryItem = deliveryEnabledItems.reduce(reducer, 0);

    if (totalDeliveryItem === addonItems[0]?.quantity) return;
    if (totalDeliveryItem === 0 && addonItems.length === 0) return;

    var newData = {
      updates: {
        [deliveryAddonId]: totalDeliveryItem,
      },
    };

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: newData,
      success: function (data) {
        console.log("here");
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:build", {
            bubbles: true,
          })
        );
      },
      error: function (err) {
        console.log(err);
      },
      dataType: "json",
    });
  }

  function toggleGiftWrap() {
    var $this = $(this);
    var line = $this.attr("data-line");
    var status = $this.prop("checked");
    var qty = parseInt($this.attr("data-qty"));

    var updateData = {
      line: line,
      quantity: qty,
      properties: {
        gift_wrap: status ? "true" : null,
      },
    };

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: updateData,
      success: function (data) {
        console.log("data => ", data);
        additionalProductChanged(data.items);
      },
      error: function (err) {
        console.log(err);
      },
      dataType: "json",
    });
  }
});

//OVERSIZED
$(function () {
  const form = $(".product-single__form");

  $(document).on("cart:updated ready ajaxProduct:added", function () {
    fetch('/cart?view=quickship-checker').then(res=>res.json()).then(async (items)=>{
      await checkOversized(items)
      checkOversized99(items)
    })
  });
  $(document).on("cart:build", function() {
    fetch('/cart?view=quickship-checker').then(res=>res.json()).then(async (items)=>{
      await checkOversized(items)
      checkOversized99(items)
    })
  })

  fetch('/cart?view=quickship-checker').then(res=>res.json()).then(async (items)=>{
    await checkOversized(items)
    checkOversized99(items)
  })

  async function checkOversized(items) {
    var oversizedAddonId = 40167575355428;

    var oversizedItems = items.filter(
      (item) => item.hasOversize === true && item.typeOversize==='OVERSIZED'
    );

    var oversizedAddonItems = items.filter(
      (item) => item.id === oversizedAddonId
    );
    // console.log('DEBUG}}}}==',oversizedItems,oversizedAddonItems);

    const reducer = (a, c) => a + c.quantity;
    const totalDeliveryItem = oversizedItems.reduce(reducer, 0);


    if (totalDeliveryItem === oversizedAddonItems[0]?.quantity) return;
    if (totalDeliveryItem === 0 && oversizedAddonItems.length === 0) return;

    var newData = {
      updates: {
        [oversizedAddonId]: totalDeliveryItem,
      },
    };

    return $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: newData,
      success: function (data) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:build", {
            bubbles: true,
          })
        );
      },
      error: function (err) {
        console.log(err);
      },
      dataType: "json",
    });
  }
  async function checkOversized99(items) {
    var oversizedAddonId = 40185290784804;

    var oversizedItems = items.filter(
      (item) => item.hasOversize === true && item.typeOversize==='OVERSIZED99'
    );

    var oversizedAddonItems = items.filter(
      (item) => item.id === oversizedAddonId
    );
    // console.log('DEBUG}}}}==',oversizedItems,oversizedAddonItems);

    const reducer = (a, c) => a + c.quantity;
    const totalDeliveryItem = oversizedItems.reduce(reducer, 0);


    if (totalDeliveryItem === oversizedAddonItems[0]?.quantity) return;
    if (totalDeliveryItem === 0 && oversizedAddonItems.length === 0) return;

    var newData = {
      updates: {
        [oversizedAddonId]: totalDeliveryItem,
      },
    };

    return $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: newData,
      success: function (data) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:build", {
            bubbles: true,
          })
        );
      },
      error: function (err) {
        console.log(err);
      },
      dataType: "json",
    });
  }

});

// Prop65

// document.addEventListener('DOMContentLoaded', function() {
//   var propmodal = document.getElementById("propmodal");
//   var propbtn = document.getElementById("propbtn");
//   var propspan = document.getElementById("propmodal_close");
//   var propWrapper = document.querySelector('.propmodal_wrap');
  
//   if(propmodal){
//     //document.body.appendChild(propmodal);
//     if(propbtn) {
//       propbtn.onclick = function () {
//         //document.documentElement.classList.add('modal-openn');
//         propmodal.style.display = "block";
//         propmodal.classList.add('open');

//       };
//     }
//     if(propspan) {
//       propspan.onclick = function () {
//         //document.documentElement.classList.remove('modal-openn');
//         propmodal.style.display = "none";
//         propmodal.classList.remove('open');

//       };
//     }
//   }

// //   window.onclick = function (event) {
// //     console.log(event.target);
// //     if (event.target.id == "propoverlay") {
// //       propmodal.style.display = "none";
// //       document.getElementById("propoverlay").remove();
// //       document.body.classList.remove('no-scroll-mod');
// //     }
// //   };
// });
// function initPropModal(h){
//   console.log(h);
//   let propmodal = h.find("#propmodal");
//   let propbtn = h.find("#propbtn");
//   let propspan = h.find("#propmodal_close");
//   let propWrapper = h.find('.propmodal_wrap');
//   if(propbtn) {
//     propbtn.click(()=>{
//       propmodal.show();
//     })
//   }
//   if(propspan) {
//     propspan.click(()=>{
//       propmodal.hide();
//     })
//   }
// };
//  //quickview prop modal
// $(document).on("quickview:load",(e,h)=>{
//   initPropModal(h);
// });
//  //quickadd prop modal
//  $(document).on("quickadd:load",(e,h)=>{
//   initPropModal(h);
// });

$(document).ready(function(){
  setTimeout(function() {
    let frame = document.getElementById("sloyalty-display");
    if (frame) {
      frame.setAttribute("title", "Loyalty Frame");
    }

  }, 2000);

  setTimeout(function() {
    let widgetFrame = document.getElementsByClassName("sloyalty-tab-widget");
    if (widgetFrame) {
      for (let i = 0; i < widgetFrame.length; i++) {
        widgetFrame[i].setAttribute("title", "Frame Loyalty Widget");
        let link = widgetFrame[i].firstElementChild;
        if (link) {
        let span = document.createElement("span");
        span.classList.add("hidden-label");
        span.innerHTML = "Loyalty Widget";
        link.appendChild(span);
        }
      }
    }
  }, 2000);
});

// Read More
// $(function() {
//   const descriptionContainer = $('.description__container');
//   const readMoreBtn = $('.description__read-more');

//   if (readMoreBtn.length) {
//     const scrollHeight = descriptionContainer.get(0).scrollHeight;
//     const clientHeight = descriptionContainer.get(0).clientHeight;
//     if (scrollHeight > clientHeight) readMoreBtn.show();

//     readMoreBtn.on('click', function(e) {
//       e.preventDefault();
//       if (descriptionContainer.hasClass('collapsed')) {
//         descriptionContainer.removeClass('collapsed').addClass('expanded');
//         $(this).text('Read Less');
//       } else {
//         descriptionContainer.removeClass('expanded').addClass('collapsed');
//         $(this).text('...Read More');
//       }
//     })
//   }
// })

// Bag Counter
// $(function() {
//   var $counterContainer = $('.bag_counter .counter')

//   if ($counterContainer.length) {
//     function randomCounter() {
//       var randomNumber = Math.floor(Math.random() * 10);
//       randomNumber = randomNumber < 3 ? randomNumber + 2 : randomNumber;
//       $counterContainer.html(randomNumber);
//     }

//     randomCounter();

//     setInterval(function() {
//       randomCounter();
//     }, 2 * 60000)
//   }
// });


//collection page sliders type slider
let slideCell = 6;
const flktyListOpt={
  cellAlign: 'left',
  contain: true,
  groupCells: 6,
  pageDots: false,
  resize: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 35, y2: 0,
    x3: 15
  }
}
//initialize collection list sliders
function initFlickityList(item){
  let flkty = Flickity.data( item );
  if(flkty) flkty.destroy();
  let newflkty=new Flickity( item, flktyListOpt);
  window.addEventListener('resize', function() {
    updateCells();
    newflkty.reposition();
    newflkty.resize();
    console.log("resize");
  });
  //console.log("CL-flickity reloaded");
}
const updateCells = () => {
  if ( matchMedia('screen and (min-width: 1281px)').matches){
    flktyListOpt.groupCells = 6;
  }
  else if ( matchMedia('screen and (max-width: 1280px)').matches
  && matchMedia('screen and (min-width: 993px)').matches) {
    flktyListOpt.groupCells = 5;
  }
  else if ( matchMedia('screen and (max-width: 992px)').matches 
  && matchMedia('screen and (min-width: 769px)').matches) {
    flktyListOpt.groupCells = 4;
  }
  else if ( matchMedia('screen and (max-width: 768px)').matches
  && matchMedia('screen and (min-width: 577px)').matches) {
    flktyListOpt.groupCells = 3;
  }
  else if ( matchMedia('screen and (max-width: 576px)').matches 
  && matchMedia('screen and (min-width: 200px)').matches) {
    flktyListOpt.groupCells = 2;
  }
  // console.log(flktyListOpt);

}
updateCells();
//sub collection slider
var elem = document.querySelector('.new-grids[data-type=subcollections]');
if(elem) {
  var flkty = new Flickity( elem, flktyListOpt);
  window.addEventListener('resize', function() {
    updateCells();
    flkty.reposition();
    flkty.resize();
  })
}
//collection list sliders
let elem2 = document.querySelectorAll('.new-grids[data-type=collection-list]');
if(elem2.length) {
  console.log("There are total "+elem2.length+" Collection List sliders");
  elem2.forEach((item)=>{initFlickityList(item);});
}

// var elem2 = document.querySelectorAll('.new-grids[data-type=collection-list]');
// if(elem2.length) {
//   elem2.forEach((item)=>{
//     new Flickity( item, flktyListOpt);
//   });

// }



/**Shuffle DOM elements**/
(function($){
  $.fn.shuffle = function() {
      var allElems = this.get(),
          getRandom = function(max) {
              return Math.floor(Math.random() * max);
          },
          shuffled = $.map(allElems, function(){
              var random = getRandom(allElems.length),
                  randEl = $(allElems[random]).clone(true)[0];
              allElems.splice(random, 1);
              return randEl;
         });
      this.each(function(i){
          $(this).replaceWith($(shuffled[i]));
      });
      return $(shuffled);
  };

})(jQuery);

/**Shuffle DOM elements**/
const flktyOptions = {
  cellAlign: 'left',
  contain: true,
  groupCells: 5,
  pageDots: false,
  prevNextButtons: true,
  adaptiveHeight: false,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 35, y2: 0,
    x3: 15
  }
}
let slideCellItem = 5;
const updateGroupCells = () => {

  if ( matchMedia('screen and (max-width: 1280px)').matches
  && matchMedia('screen and (min-width: 993px)').matches) {
    flktyOptions.groupCells = 5;
    slideCellItem = 5;
    console.log('1280px');
  }
  else if ( matchMedia('screen and (max-width: 992px)').matches 
  && matchMedia('screen and (min-width: 769px)').matches) {
    flktyOptions.groupCells = 4;
    slideCellItem = 4;
    console.log('992px');
  }
  else if ( matchMedia('screen and (max-width: 768px)').matches
  && matchMedia('screen and (min-width: 577px)').matches) {
    flktyOptions.groupCells = 3;
    slideCellItem = 3;
    console.log('768px');
  }
  else if ( matchMedia('screen and (max-width: 576px)').matches 
  && matchMedia('screen and (min-width: 200px)').matches) {
    flktyOptions.groupCells = 2;
    slideCellItem = 2;
    console.log('576px');
  }
}
updateGroupCells();
window.addEventListener('resize', function() {
  updateGroupCells();
});
document.addEventListener('recommendations:loaded', function(data) {
  var reomcomationGrid = data.detail.section.querySelector('.new-grid');
  if(reomcomationGrid.querySelectorAll('.grid-item').length <= slideCellItem) return;
  reomcomationGrid.classList.add('recommendations--slider');
  $('.recommendations--slider .grid-item').shuffle();//randomize the elements
  new theme.Slideshow(reomcomationGrid, flktyOptions);

  theme.utils.sliderUpdateAdvancedQuickship(reomcomationGrid);
});

document.addEventListener('DOMContentLoaded', function() {
  var moreProductsItems= document.querySelectorAll('#shopify-section-more-products > div');
  if(!moreProductsItems) {console.log('more products selector not found'); return};
  for (const moreproductItem of moreProductsItems) {
    const moreproductGrid = moreproductItem.querySelector('.new-grid');
    if(moreproductItem.querySelectorAll('.grid-item').length <= slideCellItem) continue;
    moreproductGrid.classList.add('moreproducts--slider');
    new theme.Slideshow(moreproductGrid,flktyOptions);

    theme.utils.sliderUpdateAdvancedQuickship(moreproductItem);
  }
});

document.addEventListener('recentlyviewed:loaded', function(data) {
  var reomcomationGrid1 = data.detail.section.querySelector('.new-grid');
  console.log("slideCellItem=>",slideCellItem);
  console.log("Recentlyviewloaded");
  if(reomcomationGrid1.querySelectorAll('.grid-item').length <= slideCellItem) return;
  reomcomationGrid1.classList.add('recommendations--slider1');
  new theme.Slideshow(reomcomationGrid1,flktyOptions);

  theme.utils.sliderUpdateAdvancedQuickship(reomcomationGrid1);

});
document.addEventListener('DOMContentLoaded', function() {
  var featuredSliderAll = document.querySelectorAll('.featured--slider');
  featuredSliderAll.forEach(function(featuredSlider,index){
    if(!featuredSlider) {console.log('featured slider not found'); return;}
    //alert('found');
    console.log(featuredSlider.querySelectorAll('.grid-item').length);
    if(featuredSlider.querySelectorAll('.grid-item').length <= slideCellItem) return;
    featuredSlider.classList.add('featured--slider--class');
    new theme.Slideshow(featuredSlider,flktyOptions);

    theme.utils.sliderUpdateAdvancedQuickship(featuredSlider);
  });



});
$(function() {
  $(document).on('click', '.spr-summary-actions-newreview', function() {
    $('#review_bottom').get(0).scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
  })

})
$(document).ready(()=>{
  let LooxH;
  refresh($("iframe.loox-frame"));
  // iframe.contents().find('.summary-contents').hide();
  // console.log(iframe.contents().find('.summary-contents'));

  function refresh(fr){
    if(fr){
      fr.attr("src",fr.attr("src"));
    }

  }

  function looxTask(){
    //if(!LOOX){return;}
    let iframe = $(this).parent().find("iframe.loox-frame");
    if (!iframe) {return;}
    LooxH=iframe;
    iframe.focus();
    let url=LOOX.root+"/widget/"+LOOX.clientId+"/reviews/"+iframe.data('p')+"?h="+LOOX.hash;
    iframe.parent().show();
    if($(this).hasClass('is-open')){
      //iframe.parent().hide();
      return;
    }
    //iframe.attr('src',url);
    //setTimeout(()=>{iframe.show();},1500);
    let srcHeight= window.localStorage.getItem('loox-h_');
    //setTimeout(()=>{srcHeight= window.localStorage.getItem('loox-h_');iframe.attr('style','height:'+srcHeight+';');},400);
    if(srcHeight){
      if(srcHeight.indexOf("vh")>-1){
        refresh(iframe);
        return;
      }
      iframe.attr('style','height:'+srcHeight+';');
      //iframe.parent().parent().parent().attr('style','height:'+srcHeight+';');
    }
    console.log("height=>",srcHeight);
  };

  function looxTaskModal(){
    //if(!LOOX){return;}
    let iframe = $(this).parent().find("iframe.loox-frame");
    if (!iframe) {return;}
    LooxH=iframe;
    iframe.focus();
    let url=LOOX.root+"/widget/"+LOOX.clientId+"/reviews/"+iframe.data('p')+"?h="+LOOX.hash;
    iframe.parent().show();
    if($(this).hasClass('is-open')){
      //iframe.parent().hide();
      return;
    }
    //iframe.attr('src',url);
    //setTimeout(()=>{iframe.show();},1500);
    let srcHeight= window.localStorage.getItem('loox-h_');
    //setTimeout(()=>{srcHeight= window.localStorage.getItem('loox-h_');iframe.attr('style','height:'+srcHeight+';');},400);
    if(srcHeight){
      if(srcHeight.indexOf("vh")>-1){
        refresh(iframe);
        return;
      }
      iframe.attr('style','height:'+srcHeight+';');
      //iframe.parent().parent().parent().attr('style','height:'+srcHeight+';');
    }
    console.log("height=>",srcHeight);
  };

  window.addEventListener("message", function(event){
    if (event.origin !== "https://loox.io"){return;}
    const d=JSON.parse(event.data);
    //console.log(event.source);
    //console.dir(d.height);
    let temp=  d.height+'px';
    if(temp.indexOf("vh")>-1){
      return;
    }
    if(d.height){
      window.localStorage.setItem('loox-h_', d.height+'px');
      console.log("stored-height=>",d.height);
    }
    else{
      return;
    }
    let srcHeight= window.localStorage.getItem('loox-h_');
    if(srcHeight){
      LooxH.attr('style','height:'+srcHeight+';');
      let p=LooxH.parent().parent().parent();
      p.attr('style','max-height:'+srcHeight+';');
      LOOX.productId=LooxH.data('p');
      console.log('updated');
    }

  }, false);

  $(document).on('Loox:quickadd',function(e,btn,frame){
    //alert('ssss');
    refresh(frame);
    //console.log(frame);
    btn.click(looxTaskModal);
  });
  //document.addEventListener("modalOpen",()=>{alert('fayed');})
  $('button.loox_RV').click(looxTask);
});

// document.addEventListener('DOMContentLoaded', function() {
// 	console.log('domcontent loaded');

//   setTimeout(function() {
//     console.log(document.querySelector('iframe.loox-frame'));
//   	let doc = document.querySelector('iframe.loox-frame').contentDocument;
//     const range = document.createRange();
//     const frag = range.createContextualFragment(`<style>body{background: red !important;}</style>`);
//     doc.body.append(frag);
//   }, 5000)

// })
document.addEventListener('DOMContentLoaded', function() {

  setTimeout(()=>{
    let container=$('.boost-pfs-filter-tree-v');
    let extraControls=$("#copyCat");
    let collapseClass='boost-pfs-filter-option-collapsed';
    const div=$('#boost-pfs-filter-tree-pf-pt-product-type-category');
    const t=$('#copyCatBtn');
    //console.log("Filter Controls=>",container.length);
    extraControls.show();
    if(extraControls.hasClass(collapseClass)){
      div.css('height','0');
    }
    else{
      div.css('height',div.prop('scrollHeight'));
    }
    //container.find('.boost-pfs-filter-options-wrapper').prepend(extraControls);
    t.click((e)=>{
      //console.log(t.prop('scrollHeight'));
      extraControls.toggleClass(collapseClass);
      if(extraControls.hasClass(collapseClass)){
        div.css('height','0');
      }
      else{
        div.css('height',div.prop('scrollHeight'));
      }
      //alert('clicked');
    });

  },500);
});
//inject asterisk button inside toolbar text and set height
document.addEventListener('DOMContentLoaded',function(){
  $('.announcement-slider__content').each(function(){
    let t=$(this);
    if(!t.find("button.asterisk").length) return;
    let clone=t.children("button").clone();
    t.find('.medium-up--hide.tool-text>p').append(t.children("button"));
    t.find('.small--hide.tool-text>p').append(clone);
  });
  
  const sliderContent=$("#AnnouncementSlider").find('.announcement-slider__content');
  let h=sliderContent.eq(0).prop("scrollHeight");
  sliderContent.each(function(){if($(this).prop("scrollHeight")>h){h=$(this).prop("scrollHeight");}});
  $("#AnnouncementSlider").find('.flickity-viewport').css("height",h+"px");
  const headerHeight=h+$('#SiteHeader').prop("scrollHeight");
  document.documentElement.style.setProperty('--topDistanceHeader', headerHeight+'px');
});
//append product bundle
document.addEventListener('DOMContentLoaded',function(){
  let container=$('.product-single__meta');
  let bundle=$('#shopify-section-product-bundle');
  if(container.length && bundle.find('.product_bundle_wrapper').length) {
    //bundle.removeClass('hide');
    container.append(bundle.html());
    bundle.children().remove();
    console.log('Bundle appended');
  }
  

});



function enableDisableFooterAccordion() {     
  const footerTitle = $('.footer__block.menu .footer__title')
  const footerMenu = $('.footer__block.menu .footer__menu')
  if(innerWidth > 768) {
    footerTitle.removeClass('accordion');
    footerMenu.removeClass('panel');
    $.each(footerMenu, function() {
      $(this).removeAttr('data-height');
    });
  } else {
    $.each(footerMenu, function() {
      $(this).attr('data-height', $(this).height());
    });
    footerTitle.addClass('accordion');
    footerMenu.addClass('panel');
    $.each($('.footer__title.accordion'), function() {
      const $this = $(this);
      $this.on('click', function() {
        const sibling = $this.siblings('.footer__menu');
        if($this.hasClass('active')) {
          sibling.height(0);
          sibling.removeClass('isOpen')
          $this.removeClass('active');
        } else {
          sibling.height(sibling.data('height')+'px');
          sibling.addClass('isOpen')
          $this.addClass('active');
        }
      })
    });

  }
   
}
window.addEventListener('load', enableDisableFooterAccordion);

$(document).ready(()=>{
  $('.no-blink').each(function(){
    $(this).removeClass('no-blink');
  });
})
let findOnYouTubeIframeAPIReady=setInterval(()=>{
  if(window.onYouTubeIframeAPIReady){
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent("youTubeReady"));
    clearInterval(findOnYouTubeIframeAPIReady);
  }
  //console.log('setinterval$onYouTubeIframeAPIReady',window.onYouTubeIframeAPIReady);
},1000);
// window.addEventListener('resize', enableDisableFooterAccordion);
    document.addEventListener('DOMContentLoaded', function() {
        function initPropModal(h){
            const wrapper=h.querySelector('.propmodal_wrap.myminimodal-_-');
            const propbtnall = h.querySelectorAll(".mini--btn.mod");
            
            propbtnall.forEach(function(propbtn){
                let propmodal=propbtn.nextElementSibling;
                let propspan=propmodal.querySelector('.modall_close');
    
                propbtn.onclick = function () {
                    let self=this;
                    let allmodals=propbtn.parentElement.querySelectorAll('.mini--propmodal');
                    allmodals.forEach(function(t){
                        if(t!=self.nextElementSibling){
                            t.classList.remove('open');
                        };
     
                    })
                    if(!self.nextElementSibling.classList.contains('open')){
                        initFocusout(wrapper);
                    }
                    self.nextElementSibling.classList.toggle('open');
                };
                propspan.onclick = function () {
                    propmodal.classList.remove('open');
                };
            });
            function initFocusout(wrap){
                let tHandler= function(e){
                    let thismodal= document.querySelector('.mini--propmodal.open');
                    if(e.target.classList.contains('mini--btn') ){return;}
                    
                    if(thismodal && !thismodal.querySelector('.modal-content').contains(e.target)){
                        console.log('true');
                        thismodal.classList.remove('open');
                    }
                    else{
                        console.log('false');
                    }
                };
                document.body.removeEventListener('click',tHandler);
                document.body.addEventListener('click',tHandler);
    
            }
        }
      if(document.querySelector('.product-section.mode')){
      	initPropModal(document.querySelector('.product-section.mode'));
      }
        //quickview prop modal
      $(document).on("quickview:load",(e,h)=>{
            initPropModal(h.get(0));
        });
        //quickadd prop modal
        $(document).on("quickadd:load",(e,h)=>{
            initPropModal(h.get(0));
        });
        
        // $('body').on('click','button',function(e){
        //   const parentBtn=e.currentTarget;
        //   const sajariClass=parentBtn.classList.item(0);
        //   const isSajari=sajariClass.includes('ModalCloseButton') && sajariClass.includes('ModalCloseButton');
        //   // console.log(isSajari);
        //   if(!isSajari) return;
        //   if(isSajari && document.body.classList.contains('no_scroll')){
        //     document.body.classList.remove('no_scroll');
        //   }
        // });


    });
    (function () {
      //dev friendly way to handle Sajari search results open
      document.addEventListener('sajari:open',function(){
        // console.log('sajari is open');
        document.documentElement.classList.contains('mobile-nav-open')?document.querySelector('button.mobile-nav-trigger').click():{};
      });
      document.addEventListener('sajari:close',function(){
        // console.log('sajari is close');
      });
      

      // $(document).on("cart:updated page:ready ajaxProduct:added", function () {
      //   console.log('%ccart:updated ready ajaxProduct:added','color:green');
    
      // });
    })()



    // let urlll="https://9f09-202-133-89-74.ngrok.io/shopify-products/quickship"

    // let urlll="https://externalinventory-staging.burkedecor.site/shopify-products/quickship"

    // fetch(urlll,
    //   {
    //     method: "POST",
    //     mode:"cors",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({'variant_id': 14159608971325}),
    //   }
    // ).then(res=>res.json()).then(data=>console.log(data))
    
    // .catch((err)=>{
    //   console.log('EXTERNAL INVENTORY APP NOT FOUND');
    // });
